import React from 'react';
import Page from 'components/page/page';
import PageSection from 'components/page/page-section';
import PageHeader from 'components/page/page-header';
import PageCookie from 'components/page-cookie/page-cookie';
import PageFooter from 'components/page/page-footer';
import Button from 'components/button/button';
import CtaBox from 'components/cta-box/cta-box';
import CtaBoxTitle from 'components/cta-box/cta-box-title';
import { Header2, P1 } from 'components/typography';
import SearchField from 'components/search-field/search-field';
import lexemes from 'components/lexemes';
import ActiveLink from 'components/active-link/active-link';
import useWindowSize from 'lib/use-window-resize';
import useIsomorphicLayoutEffect from 'lib/use-isomorphic-layout-effect';

const mobileSearchField = (mobileMode: boolean) => (
    <div
        style={{
            margin: '16px 14px 0',
        }}
    >
        {mobileMode ? <SearchField isFullWidth={true} hasContrast={true} isMobile={true} /> : null}
    </div>
);

const PageNotFound: React.FC<React.PropsWithChildren> = () => {
    const size = useWindowSize();
    const [mobileMode, setMobileMode] = React.useState<boolean | undefined>(undefined);

    useIsomorphicLayoutEffect(() => {
        if (size?.width && size?.height) {
            if (size.width < 768) {
                setMobileMode(true);
            } else if (size.height < 460) {
                setMobileMode(true);
            } else {
                setMobileMode(false);
            }
        }
    }, [size]);

    return (
        <Page
            extraClass="page--not-found"
            header={
                <PageHeader
                    bgColor="var(--color-primary-06)"
                    hasLogoUrl={true}
                    hasMenu={mobileMode}
                    hasBorder={true}
                    hasPhysicalSpace={true}
                    hasBackgroundColor={true}
                />
            }
            content={
                <>
                    {mobileMode ? mobileSearchField(mobileMode) : null}

                    <PageSection theme={PageSection.Theme.NONE}>
                        <CtaBox>
                            <CtaBoxTitle marginTop={mobileMode ? -6 : 10}>
                                <Header2 color="var(--color-primary-01)" tag="h1">
                                    {lexemes.notFound.lxBlockTitle()}
                                </Header2>
                            </CtaBoxTitle>
                            <CtaBoxTitle marginTop={mobileMode ? 24 : 56}>
                                <P1 color="var(--color-primary-01)">
                                    {lexemes.notFound.lxBlockText()}
                                </P1>
                            </CtaBoxTitle>
                            <CtaBoxTitle marginTop={mobileMode ? 24 : 48}>
                                <ActiveLink activeClassName="active">
                                    <Button
                                        href={`/`}
                                        color={Button.color.Primary}
                                        designType={Button.designType.FILLED}
                                        text={lexemes.notFound.lxBlockCTA()}
                                        size={Button.size.XLARGE}
                                        inline={true}
                                    />
                                </ActiveLink>
                            </CtaBoxTitle>
                        </CtaBox>
                    </PageSection>
                </>
            }
            footer={<PageFooter />}
            cookieNotification={<PageCookie />}
        />
    );
};

export default PageNotFound;
